import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-black text-white">
      <div className="container mx-auto px-6 py-12">
        <div className="grid md:grid-cols-2 gap-8">
          <div>
            <div className="flex items-center space-x-3 mb-6">
              <img 
                src="https://static.readdy.ai/image/2e9ecc346a2ca29966c0e167990e2bed/2a586e2a1b99f61bbfeb3b2e3f49cb76.png" 
                alt="handgepackt Logo" 
                className="h-16 w-auto"
              />
            </div>
            <p className="text-gray-300 mb-2 leading-relaxed">
              Fulfillment-Dienstleistungen aus der historischen Lederwarenfabrik in Remagen-Kripp.
            </p>
            <p className="text-gray-300 mb-4 leading-relaxed font-medium">
              <strong>Handgepackt. Auch mit Liebe.</strong>
            </p>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6">Kontakt</h4>
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <i className="ri-building-line text-gray-400 mt-1"></i>
                <div className="text-gray-300">
                  <div>handgepackt eGbR</div>
                  <div>Vertreten durch die Gesellschafter</div>
                  <div>Diana Runkel und Jan Aurel Rohde</div>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-map-pin-line text-gray-400 mt-1"></i>
                <div className="text-gray-300">
                  <div>Römerstr. 1</div>
                  <div>53424 Remagen</div>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-phone-line text-gray-400"></i>
                <span className="text-gray-300">+49 2642 2913998</span>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-printer-line text-gray-400"></i>
                <span className="text-gray-300">+49 2642 2913999</span>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-mail-line text-gray-400"></i>
                <span className="text-gray-300">hallo@handgepackt.de</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col items-center">
            <div className="text-gray-400 text-sm mb-4">
              © 2024 handgepackt eGbR. Alle Rechte vorbehalten. Handgepackt ist eine eingetragene Marke der handgepackt eGbR (Reg.-Nr. 302 025 254 794).
            </div>
            <div className="flex flex-col sm:flex-row items-center gap-4 sm:gap-0 sm:space-x-4 text-sm">
              <Link to="/datenschutz" className="text-gray-400 hover:text-white transition-colors cursor-pointer py-2 px-4 sm:p-0">
                Datenschutz
              </Link>
              <span className="text-gray-600 hidden sm:inline">|</span>
              <Link to="/impressum" className="text-gray-400 hover:text-white transition-colors cursor-pointer py-2 px-4 sm:p-0">
                Impressum
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
